"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = void 0;
var store = {
  name: 'Store',
  link: '/store',
  logo: 'Store',
  colors: {
    active: 'fontNeutralWhite',
    font: 'fontNeutralWhite',
    background: '#000000'
  },
  links: []
};
exports.store = store;